import React from "react";
import { useEffect } from "react";
import { connect } from "react-redux";

import Tippy from '@tippyjs/react';
import Icon from "@mdi/react";
import moment from "moment";
import { map } from "lodash";

import { copyToClipboard } from "../../../helper/functions";
import { mdiContentCopy } from "@mdi/js";

import { resetManagements } from "../../../redux/actions/managementActions";

const headers = ['Fecha Gestión', 'Tipo Gestión', 'Contacto', 'Seguimiento', 'Comentario', 'Fecha Compromiso', 'Hora Compromiso'];

const ManagementHistoryComponent = ({ getAllManagements, resetManagements, managements, quotationId, hidden }) => {

  useEffect(() => {
    getAllManagements(quotationId);
    return () => { resetManagements() };
  }, []);

  const contactDisplayer = (data) => data.contactType ? data.contactType.name : (data.managementType ? data.managementType.name : '-');
  const trackingDisplayer = (data) => data.trakingStatus ? (data.trakingStatus !== null ? data.trakingStatus.name : contactDisplayer(data)) : contactDisplayer(data);

  const gestionTypeValidation = (managementType) => {
    if (managementType) {
      return managementType.name !== 'Llamada' && managementType.name !== 'Correo' && managementType.name !== 'Whatsapp';
    }
    return true;
  }

  return (
    <div className="crm-history-container" hidden={hidden}>
      <div className="crm-history-table-container">
        {managements.entry.length > 0 &&
          <table>
            <thead>
              <tr>
                {map(headers, (e, index) => (<th key={`thead-${index}`} className="crm-header-history-field">{e}</th>))}
              </tr>
            </thead>
            <tbody>
              {map(managements.entry, (e, index) => (
                <tr key={`tbody-${index}`}>
                  <td className="crm-body-history-field">{moment(e.createdAt).format('DD-MM-YYYY, HH:mm')}</td>
                  <Tippy
                    content={e.managementType ? (e.managementType.name === 'Correo' ? e.email : e.phone) : ''}
                    placement='bottom'
                    disabled={gestionTypeValidation(e.managementType)}
                  >
                    <td
                      onClick={() => copyToClipboard(e.email || e.phone)}
                      className='crm-management-type crm-body-history-field'
                    >
                      <div>
                        {(e.managementType && (e.managementType.name === 'Llamada' || e.managementType.name === 'Correo' || e.managementType.name === 'Whatsapp')) &&
                          <Icon path={mdiContentCopy} />
                        }
                        <span>{e.managementType && e.managementType.name}</span>
                      </div>
                    </td>
                  </Tippy>
                  <td className="crm-body-history-field">{contactDisplayer(e)}</td>
                  <td className="crm-body-history-field">{trackingDisplayer(e)}</td>
                  <Tippy
                    content={e.comment}
                    disabled={e.comment.length <= 14}
                    placement='bottom'
                  >
                    <td className="crm-body-history-field">{e.comment.length <= 14 ? e.comment : `${e.comment.slice(0, 13)}...`}</td>
                  </Tippy>
                  <td className="crm-body-history-field">{e.callDate ? moment(e.callDate).format('DD-MM-YYYY') : '-'}</td>
                  <td className="crm-body-history-field">{e.callDate ? moment(e.callDate).format('HH:mm') : '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        }
        {managements.loading &&
          <div className="crm-gestion-empty">Obteniendo Gestiones...</div>
        }
        {!managements.loading && managements.entry.length === 0 &&
          <div className="crm-gestion-empty">Aún no hay Gestiones</div>
        }
      </div>
    </div >
  )
};

const mapStateToProps = ({ management }) => ({
  managements: management.managements,
});

const mapDispatchToProps = {
  resetManagements
};

export default connect(mapStateToProps, mapDispatchToProps)(ManagementHistoryComponent);